import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const opticianApi = createApi({
    reducerPath: 'opticianApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedOpticianApi = opticianApi.injectEndpoints({
    endpoints: (builder) => ({
        opticianList: builder.mutation({
            query: (config) => ({
                url: '/optician/search',
                method: 'POST',
                body: config,
            }),
        }),
        opticianAdd: builder.mutation({
            query: (config) => ({
                url: '/optician/add',
                method: 'POST',
                body: config,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useOpticianListMutation, useOpticianAddMutation } =
    injectedOpticianApi;
export default opticianApi;
